export default __webpack_public_path__ + "static/SR France - Ingredient & Label - Caramel Colors - Statement-ccb5c318d07289eee4a6c000d9e332c2.pdf";